import { ProviderRevenueCat } from '../external/ExternalPremiumLogin/RevenueCatProvider'
import { RevenueCatPurchase } from '../external/RevenuecatCheckout'
import { useEffect } from 'react'
import { useUserRoot } from '../user/selectors'
import { useMutation } from '@tanstack/react-query'
import httpService, { logUserOut } from '@/services/httpService'

export function MembershipRequiredPage() {
  const user = useUserRoot()

  const { mutateAsync } = useMutation({
    mutationFn: async () => {
      return await httpService.Post('/subscription/active', {})
    },
    onSuccess: () => {
      window.location.href = '/dashboard'
    },
    onError: (error) => {
      console.error('Error fetching membership status:', error)
    },
  })

  useEffect(() => {
    // Try to fetch profile and check for 428, maybe?
    mutateAsync()
  }, [user])

  return (
    <div className="membership-required-page flex flex-col items-center justify-center min-h-screen p-4">
      <ProviderRevenueCat>
        <RevenueCatPurchase />
      </ProviderRevenueCat>
      <button onClick={logUserOut} className="mt-4 text-sm text-gray-500 underline hover:text-gray-700">
        Logout
      </button>
    </div>
  )
}
